export const GET_REQUEST_LIST = "GET_REQUEST_LIST";
export const SET_REQUEST_LIST = "SET_REQUEST_LIST";

export const SEARCH_REQUEST_BY_ID = "SEARCH_REQUEST_BY_ID";
export const SET_REQUEST_BY_ID = "SET_REQUEST_BY_ID";

export const SEARCH_REQUEST_BY_FIELD = "SEARCH_REQUEST_BY_FIELD";
export const REQUEST_BY_FIELD_LIST = "REQUEST_BY_FIELD_LIST";

export const ADD_REQUEST = "ADD_REQUEST";
export const ADD_REQUEST_RESPONSE = "ADD_REQUEST_RESPONSE";

export const UPDATE_REQUEST = "UPDATE_REQUEST";
export const UPDATE_REQUEST_RESPONSE = "UPDATE_REQUEST_RESPONSE";

export const DELETE_REQUEST = "DELETE_REQUEST";
export const DELETE_REQUEST_RESPONSE = "DELETE_REQUEST_RESPONSE";

export const APPROVE_REJECT_REQUEST = "APPROVE_REJECT_REQUEST";
export const APPROVE_REJECT_REQUEST_RESPONSE = "APPROVE_REJECT_REQUEST_RESPONSE";
